const IFRAME_SRC_REGEX = /<iframe\b[^>]*\bsrc=(["'])(.*?)\1/i;
const GOOGLE_MAPS_EMBED_HOSTS = new Set([
	"google.com",
	"maps.google.com",
	"www.google.com",
]);

function isGoogleMapsEmbedUrl(value: string | null): value is string {
	if (!value) return false;

	try {
		const url = new URL(value);
		const hostname = url.hostname.toLowerCase();

		return (
			url.protocol === "https:" &&
			GOOGLE_MAPS_EMBED_HOSTS.has(hostname) &&
			url.pathname.startsWith("/maps/embed")
		);
	} catch {
		return false;
	}
}

export function normalizeVenueMapEmbedValue(
	value: string | null | undefined,
): string | null {
	if (typeof value !== "string") return null;

	const trimmed = value.trim();
	if (!trimmed) return null;

	const iframeMatch = trimmed.match(IFRAME_SRC_REGEX);
	const iframeSrc = iframeMatch?.[2]?.trim();

	return iframeSrc && iframeSrc.length > 0 ? iframeSrc : trimmed;
}

export function getVenueMapEmbedPreviewUrl(
	value: string | null | undefined,
): string | null {
	const normalized = normalizeVenueMapEmbedValue(value);
	return isGoogleMapsEmbedUrl(normalized) ? normalized : null;
}

export function isValidVenueMapEmbedValue(
	value: string | null | undefined,
): boolean {
	return getVenueMapEmbedPreviewUrl(value) !== null;
}
